import React from 'react'
import styled from 'styled-components'
import { Action } from '@@/action_pb'
import { eventLogProducer } from '@/lib/event-logger'

const CareerBanner = () => {
  const url = 'https://www.linkedin.com/company/kreditpintar/?viewAsMember=true'
  const eventClick = () => {
    eventLogProducer.push({
      action: Action.JOINUSNOWBUTTONCLICK,
    })
    window.open(url, '_blank', 'noopener,noreferrer')
  }
  return (
    <BannerBox onClick={eventClick}>
      <img className="banner-pc" src="/images/career/career-banner-pc.png" alt="career-banner" />
      <img className="banner-mobile" src="/images/career/career-banner-mobile.png" alt="career-banner" />
    </BannerBox>
  )
}

export default CareerBanner

const BannerBox = styled.div`
  cursor: pointer;

  img {
    width: 100%;
    height: auto;
    display: block;
  }

  .banner-pc {
    display: block;
  }
  .banner-mobile {
    display: none;
  }

  @media only screen and (max-width: 1000px) {
    margin-top: 61px;
    .banner-pc {
      display: none;
    }
    .banner-mobile {
      display: block;
    }
  }
  @media only screen and (min-width: 1001px) {
    max-width: 1440px;
    margin: 100px auto 0;
  }
`
